"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = useModeTokens;

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _react = require("react");

var _elementStyles = require("@rexlabs/element-styles");

function useModeTokens(baseTokens, modeTokens) {
  var _useContext = (0, _react.useContext)(_elementStyles.StylesContext),
      modes = _useContext.modes;

  return (0, _react.useMemo)(function () {
    var _context;

    return (0, _reduce.default)(_context = (0, _filter.default)(modeTokens).call(modeTokens, function (_ref) {
      var mode = _ref.mode;
      return modes[mode];
    })).call(_context, function (acc, _ref2) {
      var tokens = _ref2.tokens;
      return (0, _elementStyles.mergeTokens)(tokens, acc);
    }, baseTokens);
  }, [baseTokens, modeTokens, modes]);
}